import {DuplicateFieldsConfiguration} from "./DuplicateFieldsConfiguration";

/**
 * ServiceInVerticalTable содержит настройки шаблона столбца вертикальной таблицы услуг
 */
export class ServiceInVerticalTable {
  /**
   * Текст, выводимый в заголовочной строке. Можно локализовать. Может
   * склеиваться через пробел с текстом соседней колонки, если ячейки
   * объединяются.
   */
  public TitleRowText: string = ""

  /**
   * Флаг позволяет соединить ячейку услуги в заголовочной строке с
   * соседней услугой.
   */
  public CollapseTitleRowCellWithLeft: boolean = false

  /**
   * Порядковый номер столбца услуги.
   */
  public PositionInList: number = 0

  /**
   * Свойство позволяет отключить вычисление стоимости для каждой строки.
   * По сути отправляет только 1 запрос, используя значение стоимости из
   * первой строки. Используется для тех случаев, когда вся колонка считается
   * только единожды для всех значений.
   */
  public IsNeedCalculateSingleValue: boolean = false

  /**
   * Если включить данный флаг, то услуга не будет отображаться в листинге, когда
   * ее стоимость < 0
   */
  public IsNotVisibleWhenPriceByRequest: boolean = false

  /**
   * DuplicateFields содержит подключенные для дублирования в
   * колонке "Количество" поля и их настройки.
   */
  public DuplicateFields: DuplicateFieldsConfiguration = DuplicateFieldsConfiguration.RestoreSettings({})

  /**
   * Заглушка для запрета прямого создания объектов данного типа
   * @private
   */
  private constructor() {
  }

  /**
   * RestoreSettings выполняет восстановление данных объекта настроек
   * Функция выполняет нормализацию значений настроек.
   * Функция дополняет недостающие настройки значениями по умолчанию.
   *
   * @param data
   */
  public static RestoreSettings(data: any): ServiceInVerticalTable {
    let result = new ServiceInVerticalTable();

    if (typeof data === "string") {
      data = JSON.parse(data)
    }

    if (typeof data !== "object") {
      return result;
    }

    Object.keys(result).map((key: keyof ServiceInVerticalTable) => {
      // @ts-ignore
      result[key] = ServiceInVerticalTable.GetCorrectFieldValue(key, data[key])
    })

    return result;
  }

  /**
   * GetCorrectFieldValue выполняет восстановление данных поля из переданного значения настроек.
   * Данный метод так же проводит валидацию значения каждой из настроек поля. Метод возвращает
   * значение по умолчанию, если значение передано не корректно.
   */
  public static GetCorrectFieldValue<T extends keyof ServiceInVerticalTable>(field: T, data: any): any {
    let defaults = new ServiceInVerticalTable()

    if (data === undefined) {
      return defaults[field]
    }

    switch (field) {
      case "PositionInList":
        return typeof data === "number" && data >= 0 ? data : defaults[field]
      case "CollapseTitleRowCellWithLeft":
      case "IsNeedCalculateSingleValue":
      case "IsNotVisibleWhenPriceByRequest":
        return !!data
      case "TitleRowText":
        return typeof data === "string" ? data : defaults[field]
      case "DuplicateFields":
        return DuplicateFieldsConfiguration.RestoreSettings(data)
    }

    return defaults[field];
  }
}